import { render, staticRenderFns } from "./PetImageLayer.vue?vue&type=template&id=22e15021&scoped=true&"
import script from "./PetImageLayer.vue?vue&type=script&lang=js&"
export * from "./PetImageLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e15021",
  null
  
)

export default component.exports